module.exports = __webpack_public_path__ + "static/media/inoon_logo.f7efecad.png";